export const environment = {
  production: false,
  strEnvironment: 'Development',
  // Dev API
  // api: 'http://localhost:8080/api/v1',  
  // Api GKE projectId techforb-finsuite
  api: '/api/v1',
  rangeFiltersMonth: 3,
  recaptchaSiteKey: '6Lc6MG8tAAAAAGKVh3B3VMRt7kVOoECX7pK9G-8f'

};
